module.exports = __webpack_public_path__ + "img/regex.ed092038.png";